import CircularProgress from "@mui/material/CircularProgress";

export default function Loader() {
  return (
    <div className={"centered"}>
      <CircularProgress />
    </div>
  );
}
